import { Plugin, Widget, toWidget } from 'ckeditor5';
import katex from 'katex';
import InsertMathEquationCommand from './mathequationcommand';

function renderKatexInto(domElement, latex) {
  try {
    katex.render(latex, domElement, { throwOnError: false });
  } catch (e) {
    domElement.textContent = latex;
  }
}

export default class MathEquationEditing extends Plugin {
  static get requires() {
    return [Widget];
  }

  static get pluginName() {
    return 'MathEquationEditing';
  }

  init() {
    this._defineSchema();
    this._defineConverters();
    this.editor.commands.add('insertMathEquation', new InsertMathEquationCommand(this.editor));
  }

  _defineSchema() {
    const schema = this.editor.model.schema;
    schema.register('mathEquation', {
      inheritAllFrom: '$inlineObject',
      allowAttributes: ['latex'],
    });
  }

  _defineConverters() {
    const editor = this.editor;
    const conversion = editor.conversion;

    // Reads existing HTML (old questions you've saved with this editor,
    // or content you migrate) back into the model.
    conversion.for('upcast').elementToElement({
      view: { name: 'span', classes: 'math-tex' },
      model: (viewElement, { writer }) => {
        const latex = viewElement.getAttribute('data-latex') || '';
        return writer.createElement('mathEquation', { latex });
      },
    });

    // What the user sees and can click/double-click while editing.
    conversion.for('editingDowncast').elementToElement({
      model: 'mathEquation',
      view: (modelElement, { writer }) => {
        const latex = modelElement.getAttribute('latex') || '';
        const span = writer.createContainerElement(
          'span',
          { class: 'math-tex', 'data-latex': latex },
          [
            writer.createRawElement('span', {}, (domEl) => renderKatexInto(domEl, latex)),
          ]
        );
        return toWidget(span, writer, { label: 'Math/chemistry equation' });
      },
    });

    // What gets saved (editor.getData()). Baking the rendered KaTeX HTML
    // straight into the saved HTML means your question-display pages only
    // need katex.min.css loaded to look right -- no JS re-render required,
    // matching how your old Wiris-rendered questions already behave.
    conversion.for('dataDowncast').elementToElement({
      model: 'mathEquation',
      view: (modelElement, { writer }) => {
        const latex = modelElement.getAttribute('latex') || '';
        return writer.createContainerElement(
          'span',
          { class: 'math-tex', 'data-latex': latex },
          [
            writer.createRawElement('span', {}, (domEl) => renderKatexInto(domEl, latex)),
          ]
        );
      },
    });
  }
}